import api from './api';
import DateHelper from '@/helpers/dateHelper';

const URLS = {
  createReservation: 'createReservation',
  createGiftCardReservation: 'createGiftCardReservation',
  cartAPI: 'cart',
  groupBookingCartAPI: 'groupBookingCart',
  groupBookingConfirmReservations: 'groupBookingConfirmReservations',
};

export const createReservation = (
  customer,
  totalAmount,
  depositAmount,
  propertyId,
  amountPaid,
  paymentIntentId,
  items,
  promoCode,
  giftCardId,
  giftCardAmountApplied,
  withoutPyament,
) => {
  return api.post(URLS.createReservation, {
    ...customer,
    totalAmount: totalAmount,
    depositAmount: depositAmount,
    propertyId: propertyId,
    amountPaid: amountPaid,
    paymentIntentId: paymentIntentId,
    promoCode: promoCode,
    giftCardId: giftCardId,
    giftCardAmountApplied: giftCardAmountApplied,
    withoutPyament: withoutPyament,
    itemList: items.map((item) => {
      return {
        dateRateList: item.dateRateList,
        numberOfRooms: item.numberOfRooms,
        roomTypeId: item.roomType.id,
        checkInDate: DateHelper.defaultFormat2(item.dateRateList[0].date),
        checkOutDate: DateHelper.defaultFormat2(
          DateHelper.addDay(item.dateRateList[item.dateRateList.length - 1].date),
        ),
        people: item.people,
        cleaningFees: item.chargesAndTaxes.cleaningFees,
      };
    }),
  });
};

export const createGiftCardReservation = (body) => {
  return api.post(URLS.createGiftCardReservation, body);
};

export const cartAPI = (createReservationRequest, people) => {
  return api.post(URLS.cartAPI, {
    propertyId: createReservationRequest.propertyId,
    itemList: createReservationRequest.items.map((item) => {
      return {
        dateRateList: item.dateRateList,
        numberOfRooms: item.numberOfRooms,
        roomTypeId: item.roomType.id,
        checkInDate: DateHelper.defaultFormat2(item.dateRateList[0].date),
        checkOutDate: DateHelper.defaultFormat2(
          DateHelper.addDay(item.dateRateList[item.dateRateList.length - 1].date),
        ),
        people: people,
        cleaningFees: item.chargesAndTaxes.cleaningFees,
      };
    }),
  });
};

export const groupBookingCartAPI = (createReservationRequest) => {
  return api.post(URLS.groupBookingCartAPI, {
    itemList: createReservationRequest.items.map((item) => {
      return {
        reservationRoomId: item.reservationRoomId,
      };
    }),
  });
};

export const groupBookingConfirmReservations = (
  customer,
  totalAmount,
  depositAmount,
  propertyId,
  amountPaid,
  paymentIntentId,
  items,
  promoCode,
) => {
  return api.post(URLS.groupBookingConfirmReservations, {
    ...customer,
    totalAmount: totalAmount,
    depositAmount: depositAmount,
    propertyId: propertyId,
    amountPaid: amountPaid,
    paymentIntentId: paymentIntentId,
    promoCode: promoCode,
    itemList: items.map((item) => {
      return {
        reservationRoomId: item.reservationRoomId,
      };
    }),
  });
};
